import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import DashboardLayout from '../Layout/DashboardLayout';
import LoadingSpinner from '../Common/LoadingSpinner';
import { requestHelpers } from '../../services/api';
import './CTWAAdManager.css';

const CTWAAdManager = () => {
    const [ads, setAds] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showOrchestrate, setShowOrchestrate] = useState(false);
    
    // Orchestration State
    const [formData, setFormData] = useState({
        name: '',
        budget: { amount: 500, type: 'DAILY' },
        targeting: {
            locations: ['IN'],
            ageMin: 18,
            ageMax: 65,
            genders: [1, 2]
        },
        creative: {
            title: 'Chat with us!',
            body: 'Get exclusive offers on WhatsApp.',
            imageHash: ''
        }
    });

    useEffect(() => {
        fetchAds();
    }, []);

    const fetchAds = async () => {
        try {
            setLoading(true);
            const response = await requestHelpers.get('/ads');
            if (response.success) setAds(response.data);
        } catch (error) {
            toast.error('Failed to load ads');
        } finally {
            setLoading(false);
        }
    };

    const handleOrchestrate = async (e) => {
        e.preventDefault();
        try {
            const result = await requestHelpers.post('/ads/orchestrate', formData);
            if (result.success) {
                toast.success('Ad orchestration started successfully!');
                setShowOrchestrate(false);
                fetchAds();
            } else {
                toast.error(result.message);
            }
        } catch (error) {
            toast.error(error.message || 'Orchestration failed');
        }
    };

    if (loading) return <LoadingSpinner />;

    return (
        <DashboardLayout>
            <div className="ads-container">
                <header className="page-header">
                    <div>
                        <h1>Click to WhatsApp Ads</h1>
                        <p>Launch Meta ads that lead directly to your WhatsApp chat.</p>
                    </div>
                    <button className="btn-primary" onClick={() => setShowOrchestrate(true)}>
                        <i className="fas fa-bullhorn"></i> New Ad Campaign
                    </button>
                </header>

                <div className="ads-list">
                    {ads.map(ad => (
                        <div key={ad.adId} className="ad-row">
                            <div className="ad-main">
                                <h3>{ad.name}</h3>
                                <span className={`ad-status ${ad.status.toLowerCase()}`}>{ad.status}</span>
                            </div>
                            <div className="ad-details">
                                <div>Budget: ₹{ad.budget.amount} / {ad.budget.type}</div>
                                <div>ID: {ad.adId || 'Syncing...'}</div>
                            </div>
                            <div className="ad-actions">
                                {ad.status === 'IN_PROCESS' && ad.adId && (
                                    <button className="btn-publish" onClick={() => {/* Publish logic */}}>Publish</button>
                                )}
                            </div>
                        </div>
                    ))}
                    {ads.length === 0 && (
                        <div className="empty-state">No active ad campaigns found.</div>
                    )}
                </div>

                {showOrchestrate && (
                    <div className="modal-overlay">
                        <div className="modal-content orchestration-modal">
                            <h2>Orchestrate New Ad</h2>
                            <form onSubmit={handleOrchestrate}>
                                <div className="form-group">
                                    <label>Campaign Name</label>
                                    <input type="text" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} placeholder="Summer Promo 2024" required />
                                </div>
                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Daily Budget (INR)</label>
                                        <input type="number" value={formData.budget.amount} onChange={(e) => setFormData({...formData, budget: {...formData.budget, amount: e.target.value}})} required />
                                    </div>
                                    <div className="form-group">
                                        <label>Target Min Age</label>
                                        <input type="number" value={formData.targeting.ageMin} onChange={(e) => setFormData({...formData, targeting: {...formData.targeting, ageMin: e.target.value}})} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Ad Body Text</label>
                                    <textarea value={formData.creative.body} onChange={(e) => setFormData({...formData, creative: {...formData.creative, body: e.target.value}})} placeholder="What should the ad say?" required />
                                </div>
                                <div className="modal-actions">
                                    <button type="button" className="btn-cancel" onClick={() => setShowOrchestrate(false)}>Cancel</button>
                                    <button type="submit" className="btn-submit">Launch Orchestration</button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </DashboardLayout>
    );
};

export default CTWAAdManager;
